<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnEditVisible="true">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="toolbar">
            <print-component v-if="isBtnStampa" :documentRepository="true" :idRisorsa="idRisorsa"></print-component>
            <!-- <b-button size="sm" variant="btn--md btn-light waves-effect waves-light btn-toolbar  float-sm-right" @click="loadStampeReport" :hidden="isBtnStampa">
				<b-icon icon="printer"></b-icon>
				Stampa
			</b-button> -->
        </template>
        <template slot="table-body">
            <rsa-accettazione-view-component ref="cmpRsaAccettazioneViewComponent" @beforeLoadData="onBeforeloadData" @afterLoadData="onAfterLoadData" @updateIdDocumentRepository="onUpdateIdDocumentRepository" :isViewMode="false"></rsa-accettazione-view-component>
            <modal-error ref="cmpModalError"></modal-error>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import RsaAccettazioneViewComponent from "../../rsaaccettazione/components/RsaAccettazioneViewComponent.vue";
export default {
    props: {
        utente: { type: Object },
    },
    components: {
        ModalError,
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        PrintComponent,
        RsaAccettazioneViewComponent,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            idRisorsa: null,
            filtro: {},
            btnNewVisible: true,
            pathResource: null,
            pathResourceAccettazione: "/rsaaccettazioni",
            linkedit: "/rsapaziente/schedaospite/edit/",
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            linkPrintData: "",
            listKey: 0,
            activeTabIndex: 0,
            isPageGestioneOspite: true,
            isBtnStampa: true,
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        me.idRisorsa = me.idAccettazione;
        me.linkPrintData = "/rsaaccettazioni/printdata/" + me.idAccettazione;
        me.linkedit += me.idAccettazione;
        me.loadAccettazione();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRsaAccettazioneViewComponent.setId(me.idAccettazione, true);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onInputTabs(index) {
            let me = this;
            let activeTab = this.$refs.tabsRsaAccettazioneEdit.getTabs()[index];

            me.activeTab(activeTab.id);
        },
        activeTab(idActiveTab) {
            let me = this;
            me.isBtnStampa = false;
            switch (idActiveTab) {
                case "tbPersoneRiferimento":
                    me.$refs.cmpRsaPersonaRiferimento.loadData(me.idAccettazione);
                    break;
                case "tbImpegnativa":
                    me.$refs.cmpRsaImpegnativaList.loadData(me.idAccettazione);
                    break;
                case "tbSpeseExtra":
                    me.$refs.cmpRsaSpesaExtraList.setId(me.idAccettazione);
                    break;
                case "tbPresenza":
                    me.$refs.cmpRsaUsciteList.init(me.jsonData);
                    break;
                case "tbImpegnative":
                    me.$refs.cmpRsaImpegnativeListComponent.init(me.jsonData);
                    break;
                case "tbAnagrafica":
                    me.$refs.cmpRsaAccettazioneAnagraficaViewComponent.setId(me.idAccettazione);
                    me.isBtnStampa = true;
                    break;
                case "tbDatiFatturazione":
                    me.$refs.cmpRsaAccettazioneDatiFatturazione.init(me.jsonData);
                    break;
                // case "tbDimissioniTrasferimeti":
                //     me.$refs.cmpRsaDimissioneTrasferimento.setId(me.idAccettazione);
                //     break;
            }
        },
        loadStampeReport() {
            let me = this;
            // me.printData = {};
            me.loadDataResources(me.linkPrintData, null, me.resultResponseStampa, me.resultErrorStampa);
        },
        resultResponseStampa(response) {
            let me = this;
            me.reportName = response.data.data.reportName;
            me.printData = response.data.data;

            me.$refs.cmpPrint.print(response.data.data);
        },
        resultErrorStampa(error) {
            let me = this;
            let messaggio = error.response.messaggio ? error.response.messaggio : "Stampa non disponibile";
            me.$refs.cmpModalError.show(messaggio + "#");
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeloadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onUpdateIdDocumentRepository(id) {
            let me = this;
            me.idRisorsa = id;
        },
    },
};
</script>

<style></style>
